(function() { module.exports = window["vuedraggable"]; }());